

$( document ).ready(function() {
    $(".navbar-toggler").click(function(){
        $(".collapse").slideToggle();
         });

$(".dropdown-toggle").click(function(){
    $(this).parent().toggleClass("activenav");
});
     
$('.acc-container .acc:nth-child(1) .acc-head').addClass('active');
$('.acc-container .acc:nth-child(1) .acc-content').slideDown();
$('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
    $(this).siblings('.acc-content').slideUp();
    $(this).removeClass('active');
    }
    else {
    $('.acc-content').slideUp();
    $('.acc-head').removeClass('active');
    $(this).siblings('.acc-content').slideToggle();
    $(this).toggleClass('active');
    }
});  




       let = swiper = new Swiper('.videoslider',  {
    spaceBetween: 1,
    slidesPerView: 1.2,
    centeredSlides: true,
    //roundLengths: true,
    loop: true, 
    spaceBetween: 8,
	 //speed:5000,
    navigation: {
      nextEl: ".swiper-button-next1",
      prevEl: ".swiper-button-prev1"
    },
    pagination: {
        el: ".swiper-pagination11",
        clickable: true
      },
    breakpoints: {
    768: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    1200: {
      slidesPerView: 5,
    },
     1440: {
       centeredSlides: false,
       spaceBetween: 10,
      slidesPerView: 5,
      
    },
  }
  });



      var swiper = new Swiper(".mySwiper5", {
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      loop: true, 
    });
    var swiper25 = new Swiper(".mySwiper25", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next2",
        prevEl: ".swiper-button-prev2",
      },
      thumbs: {
        swiper: swiper,
      },
    });



          $(".videoslider .swiper-slide").on("click", function () {
  var currentVideo = $(this).find("video").get(0);
  // Pause all videos except the clicked one
  $(".videoslider video").each(function () {
    if (this !== currentVideo) {
      this.pause();
      $(this).closest(".swiper-slide").find(".playbtn").fadeIn(300);
    }
  });
  // Toggle current video
  if (currentVideo.paused) {
    currentVideo.play();
    $(this).find(".playbtn").fadeOut(500);
  } else {
    currentVideo.pause();
    $(this).find(".playbtn").fadeIn(500);
  }

});


});	

   






   

   